import { render, staticRenderFns } from "./RechercheIngredients.vue?vue&type=template&id=882ecc08&scoped=true&"
import script from "./RechercheIngredients.vue?vue&type=script&lang=js&"
export * from "./RechercheIngredients.vue?vue&type=script&lang=js&"
import style0 from "./RechercheIngredients.vue?vue&type=style&index=0&id=882ecc08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882ecc08",
  null
  
)

export default component.exports